export enum BundlePlaceSelectionType {
  Master = 'MASTER',
  Independent = 'INDEPENDENT',
  Fixed = 'FIXED'
}
